export default function iconByMimeType(mimeType) {
  if (mimeType.includes('image/')) {
    return 'fa fa-file-image-o';
  }

  if (mimeType.includes('application/pdf')) {
    return 'fa fa-file-pdf-o';
  }

  if (mimeType.includes('word') || mimeType.includes('opendocument.text')) {
    return 'fa fa-file-word-o';
  }

  if (mimeType.includes('text/')) {
    return 'fa fa-file-text-o';
  }

  return 'fa fa-file-o';
}
